<template>
    <div
        id="be-gallery-settings"
        class="bg-light"
    >
        <div class="body-wrapper">
            <main class="pt-0">
                <div class="barra-titolo-azioni bg-white border-bottom py-2 mt-0">
                    <div class="container-fluid">
                        <div class="row d-flex justify-content-between flex-wrap align-items-center">
                            <div class="col-sm-7 d-flex justify-content-start align-items-center">
                                <div class="navbar-nav pulsante-indietro">
                                    <a
                                        title="Indietro"
                                        @click="goToGallery"
                                    >
                                        <font-awesome-icon :icon="['fas', 'arrow-left']" />
                                    </a>
                                </div>
                                <div class="ml-3">
                                    <h1 class="mb-0 text-blurikorda">
                                        <span class="titolo-gallery">{{ $t("Impostazioni galleria") }}</span>
                                    </h1>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <b-container
                    fluid
                    class="settings-container pt-3"
                >
                    <loading-animation
                        class="loading"
                        v-show="!loaded"
                    ></loading-animation>

                    <ValidationObserver v-slot="{handleSubmit}">
                        <b-form
                            @submit.prevent="handleSubmit(onSubmit)"
                            v-show="loaded"
                        >

                            <div class="mt-3">
                                <h5>{{$t('Galleria')}}</h5>
                                <b-form-row>
                                    <div class="col-sm-12 col-md-12 text-right small">
                                        {{$t('Url galleria')}}: <span id="be-event-url">{{event.url}}</span>
                                    </div>
                                </b-form-row>
                                <b-form-row>
                                    <b-form-group
                                        :label="$t('Titolo')"
                                        class="col-sm-12 col-md-6"
                                    >
                                        <validation-provider
                                            rules="required"
                                            v-slot="{ errors }"
                                        >
                                            <b-form-input
                                                class="rounded-pill rilievo-ombra-interna"
                                                v-model="event.titolo"
                                                :placeholder="$t('Inserisci un titolo')"
                                                trim
                                            ></b-form-input>
                                            <span class="text-danger">{{errors[0]}}</span>
                                        </validation-provider>
                                    </b-form-group>

                                    <b-form-group
                                        :label="$t('Stato')"
                                        class="col-sm-12 col-md-6"
                                    >
                                        <b-form-select
                                            class="rounded-pill rilievo-ombra-interna"
                                            v-model="event.stato"
                                            :options="stateOptions"
                                        ></b-form-select>
                                    </b-form-group>
                                </b-form-row>

                                <b-form-row>
                                    <b-form-group
                                        :label="$t('Data')"
                                        class="col-sm-12 col-md-6"
                                    >
                                        <b-form-datepicker
                                            class="rounded-pill rilievo-ombra-interna"
                                            v-model="event.dataEvento"
                                            trim
                                            min="2000-01-01"
                                            max="2099-12-31"
                                            :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                                            :label-help="$t('Usa i tasti freccia navigare tra le date')"
                                        ></b-form-datepicker>
                                    </b-form-group>

                                    <b-form-group
                                        :label="$t('Data scadenza')"
                                        class="col-sm-12 col-md-6"
                                    >
                                        <b-form-datepicker
                                            class="rounded-pill rilievo-ombra-interna"
                                            v-model="event.dataScadenza"
                                            trim
                                            min="2000-01-01"
                                            max="2099-12-31"
                                            :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                                            :label-help="$t('Usa i tasti freccia navigare tra le date')"
                                            :label-no-date-selected="$t('Nessuna scadenza')"
                                        ></b-form-datepicker>
                                    </b-form-group>
                                </b-form-row>

                                <b-form-row>
                                    <b-form-group
                                        :label="$t('Impostazioni di vendita evento:')"
                                        class="col-sm-12 col-md-6"
                                    >
                                        <b-form-select
                                            class="rounded-pill rilievo-ombra-interna"
                                            v-model="event.modalita"
                                        >
                                            <b-form-select-option value="DEFAULT">{{ $t("Visione e vendita") }}</b-form-select-option>
                                            <b-form-select-option value="VIEWONLY">{{ $t("Sola visione") }}</b-form-select-option>
                                        </b-form-select>
                                    </b-form-group>

                                    <b-form-group
                                        :label="$t('Listino')"
                                        class="col-sm-12 col-md-6"
                                        v-if="event.modalita!='VIEWONLY'"
                                    >
                                        <validation-provider
                                            rules="requiredPricelist"
                                            v-slot="{ errors }"
                                        >

                                            <b-form-select
                                                class="rounded-pill rilievo-ombra-interna"
                                                v-model="pricelistSelected"
                                                :options="pricelistOptions"
                                                @change="onPricelistChanged"
                                            >
                                                <template #first>
                                                    <b-form-select-option
                                                        :value="''"
                                                        disabled
                                                    >{{ $t("-- Seleziona un listino --") }}
                                                    </b-form-select-option>
                                                </template>
                                            </b-form-select>
                                            <span class="text-danger">{{errors[0]}}</span>
                                        </validation-provider>
                                    </b-form-group>
                                </b-form-row>
                            </div>

                            <div class="mt-3">
                                <h5>{{$t('Tipo evento')}}</h5>
                                <b-form-row>
                                    <b-form-group class="col-sm-6 col-md-2">
                                        <b-col sm="12">
                                            <b-form-radio
                                                name="tipoEvento"
                                                value="PUBBLICO"
                                                v-model="event.tipoEvento"
                                            >
                                                {{ $t("Pubblico") }}
                                            </b-form-radio>
                                        </b-col>
                                        <b-col sm="12">
                                            <b-form-radio
                                                name="tipoEvento"
                                                value="PRIVATO"
                                                v-model="event.tipoEvento"
                                            >
                                                {{ $t("Privato") }}
                                            </b-form-radio>
                                        </b-col>
                                    </b-form-group>
                                    <b-form-group
                                        :label="$t('Inserisci gli indirizzi email')"
                                        class="col-sm-6 col-md-4"
                                        v-show="event.tipoEvento ==='PRIVATO'"
                                    >
                                        <b-form-textarea
                                            no-resize
                                            @blur="addToEmailsList"
                                        ></b-form-textarea>
                                    </b-form-group>

                                    <div
                                        class="col-sm-12 col-md-6 emails-list-container"
                                        v-show="event.tipoEvento ==='PRIVATO'"
                                    >
                                        <b-container style="padding-right: 30px;">
                                            <b-row class="col-form-label pt-0">
                                                <b-col sm="7">{{ $t("Lista indirizzi email inseriti") }} ({{emailsListCount}})</b-col>
                                                <b-col
                                                    sm="2"
                                                    class="text-center"
                                                >{{ $t("Abilitato") }}</b-col>
                                                <b-col
                                                    sm="2"
                                                    class="text-center"
                                                >{{ $t("Elimina") }}</b-col>
                                            </b-row>
                                        </b-container>
                                        <b-container class="emails-list form-control">
                                            <b-row
                                                v-for="emailRow in event.emailsList"
                                                :key="emailRow.Email"
                                            >
                                                <b-col sm="7">{{ emailRow.Email }}</b-col>
                                                <b-col
                                                    sm="2"
                                                    class="text-center"
                                                >
                                                    <font-awesome-icon
                                                        :icon="['fas', 'check']"
                                                        v-if="emailRow.Flagabilitato === '1'"
                                                        class="text-success"
                                                    />
                                                    <font-awesome-icon
                                                        :icon="['fas', 'times']"
                                                        v-if="emailRow.Flagabilitato === '0'"
                                                        class="text-danger"
                                                    />
                                                </b-col>
                                                <b-col
                                                    sm="2"
                                                    class="text-center"
                                                >
                                                    <b-link
                                                        class="text-danger"
                                                        href="javascript:void(0)"
                                                        @click="removeEmail(emailRow.Email)"
                                                    >
                                                        <font-awesome-icon :icon="['fas', 'trash']" />
                                                    </b-link>
                                                </b-col>
                                            </b-row>
                                        </b-container>
                                    </div>
                                </b-form-row>
                            </div>

                            <div class="mt-3">
                                <h5>{{ $t('Modalità di consegna e pagamento') }}</h5>
                                <settings-delivery-and-payments-section
                                    class="mx-4"
                                    v-show="event.modalita!='VIEWONLY'"
                                    ref="settingsDeliveryAndPaymentsSection"
                                    :settings="event"
                                />
                            </div>

                            <div class="mt-3">
                                <h5>{{ $t('Impostazioni Watermark') }}</h5>
                                <b-form-row class="mx-4 mt-3">
                                    <b-form-group class="col-sm-12">
                                        <b-col sm="12">
                                            <b-form-radio
                                                name="tipoWatermark"
                                                value="DEFAULT"
                                                v-model="tipoWatermark"
                                                @change="onTipoWatermarkChanged"
                                            >
                                                {{ $t("Usa watermark predefinito") }}
                                            </b-form-radio>
                                        </b-col>
                                        <b-col sm="12">
                                            <b-form-radio
                                                name="tipoWatermark"
                                                value="CUSTOM"
                                                v-model="tipoWatermark"
                                                @change="onTipoWatermarkChanged"
                                            >
                                                {{ $t("Usa watermark personalizzato per questo evento") }}
                                            </b-form-radio>
                                        </b-col>
                                    </b-form-group>

                                    <backend-watermark-editor
                                        ref="watermarkEditor"
                                        v-if="tipoWatermark=='CUSTOM' && idWatermark && idWatermark!=event.idWatermarkDefault"
                                        :idWatermark="idWatermark"
                                        class="border border-solid border-gray-50"
                                    />

                                </b-form-row>
                            </div>

                            <div class="mt-3">
                                <b-form-row>
                                    <b-button
                                        type="submit"
                                        variant="primary"
                                        :disabled="saving"
                                        class="col-sm-12 col-md-4 offset-md-4 btn-rikorda1"
                                    >
                                        {{ saving ? $t("Salvataggio") : $t("Salva") }}
                                    </b-button>
                                </b-form-row>
                            </div>
                        </b-form>
                    </ValidationObserver>
                </b-container>
            </main>

            <backend-footer />

        </div>
    </div>
</template>

<script>
import LoadingAnimation from "../../components/LoadingAnimation";
import BackendFooter from "../../components/backend/Footer";
import BackendWatermarkEditor from "../../components/backend/WatermarkEditor";
import SettingsDeliveryAndPaymentsSection from "../../components/backend/SettingsDeliveryAndPaymentsSection";
import { ValidationProvider, ValidationObserver, extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";

export default {
    name: "BackendGallerySettings",

    components: {
        LoadingAnimation,
        BackendFooter,
        BackendWatermarkEditor,
        SettingsDeliveryAndPaymentsSection,
        ValidationProvider,
        ValidationObserver
    },

    data() {
        return {
            loaded: false,
            eventId: "",
            event: {},
            tipoWatermark: "DEFAULT",
            idWatermark: "",
            idWatermarkEvent: "",
            downloadedEventType: "",
            stateOptions: [
                { value: "ATTIVO", text: "Attiva" },
                { value: "NON ATTIVO", text: "Non attiva" }
            ],
            pricelistOptions: [],
            pricelistSelected: null,
            pricelistRatioChanged: false,

            saving: false,
            EMAIL_REGEXP:
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        };
    },

    computed: {
        isValid() {
            return this.$refs.settingsDeliveryAndPaymentsSection.isValid;
        },

        emailsListCount() {
            return this.event && this.event.emailsList
                ? this.event.emailsList.length
                : 0;
        }
    },

    beforeMount() {
        extend("required", {
            ...required,
            message: this.$t("Campo obbligatorio")
        });
        extend("requiredPricelist", {
            ...required,
            message: this.$t("Seleziona un listino prezzi")
        });
    },

    mounted() {
        this.eventId = this.$route.params.eventId;
        this.loadSettings();
    },

    methods: {
        loadSettings() {
            this.$api.backendGetEventSettings(this.eventId).then((response) => {
                console.debug("BACKEND_GET_EVENT_SETTINGS", response);
                if (response.event) {
                    this.event = response.event;
                    if (
                        this.event.fkWatermark == this.event.idWatermarkDefault
                    ) {
                        this.tipoWatermark = "DEFAULT";
                        this.idWatermark = this.event.idWatermarkDefault;
                    } else {
                        this.tipoWatermark = "CUSTOM";
                        this.idWatermarkEvent = this.event.fkWatermark;
                        this.idWatermark = this.idWatermarkEvent;
                    }
                    this.downloadedEventType = this.event.tipoEvento;
                    this.event.emailsToAdd = [];
                    this.event.emailsToRemove = [];
                    this.pricelistOptions = response.pricelists;
                    this.pricelistSelected = this.event.fkListino;
                    this.$refs.settingsDeliveryAndPaymentsSection.loaded = true;
                    this.loaded = true;
                }
            });
        },

        filterUrl(newValue) {
            newValue = newValue
                .trim()
                .toLowerCase()
                .substr(0, 255)
                .replace(/ /g, "-");
            newValue = newValue.replace(/[^\w\s^-]/gi, "");
            this.event.url = newValue;
        },

        addToEmailsList($event) {
            var value = $event.target.value;
            if (typeof value === "string") {
                value = value
                    .trim()
                    .toLowerCase()
                    .replace(/[,\r,\n,\t]/gm, " ")
                    .replace(/  +/g, " ");
                var i,
                    email,
                    j,
                    toAdd,
                    valueAsArray = value.split(" ");
                for (i = 0; i < valueAsArray.length; i++) {
                    email = valueAsArray[i];
                    if (email.length > 0 && this.EMAIL_REGEXP.test(email)) {
                        toAdd = true;
                        for (j = 0; j < this.event.emailsList.length; j++) {
                            if (this.event.emailsList[j].Email === email) {
                                toAdd = false;
                                break;
                            }
                        }
                        if (toAdd) {
                            this.event.emailsList.push({
                                Email: email,
                                Flagabilitato: "1"
                            });
                            this.event.emailsToAdd.push(email);
                            if (this.event.emailsToRemove.indexOf(email) > -1) {
                                this.event.emailsToRemove.splice(
                                    this.event.emailsToRemove.indexOf(email),
                                    1
                                );
                            }
                        }
                    }
                }
            }
            $event.target.value = "";
        },

        removeEmail(email) {
            for (var i = 0; i < this.event.emailsList.length; i++) {
                if (this.event.emailsList[i].Email === email) {
                    this.event.emailsList.splice(i, 1);
                    if (this.event.emailsToRemove.indexOf(email) === -1) {
                        this.event.emailsToRemove.push(email);
                    }
                    if (this.event.emailsToAdd.indexOf(email) > -1) {
                        this.event.emailsToAdd.splice(
                            this.event.emailsToAdd.indexOf(email),
                            1
                        );
                    }
                    break;
                }
            }
        },

        removeCover() {
            return this.$api.backendSetEventSettings(this.eventId, {
                idCopertina: ""
            });
        },

        _saveEventSettings() {
            return new Promise((resolve, reject) => {
                this.$api
                    .backendSetEventSettings(this.eventId, this.event)
                    .then((response) => {
                        console.debug("BACKEND_SET_EVENT_SETTINGS", response);
                        if (this.event.tipoEvento === "PUBBLICO") {
                            this.event.emailsList = [];
                        }
                        this.event.emailsToAdd = [];
                        this.event.emailsToRemove = [];

                        // se l'evento è passato da PUBBLICO A PRIVATO => rimuove la copertina
                        if (
                            this.downloadedEventType === "PUBBLICO" &&
                            this.event.tipoEvento === "PRIVATO"
                        ) {
                            this.removeCover();
                        }

                        if (
                            this.event.fkWatermark ==
                            this.event.idWatermarkDefault
                        ) {
                            // se salva il watermark predefinito, resetta il watermark evento perché lato server è stato rimosso
                            this.idWatermarkEvent = null;
                        }

                        resolve();
                    })
                    .catch((error) => {
                        console.error("BACKEND_SET_EVENT_SETTINGS", error);
                        reject();
                    })
                    .finally(() => {
                        this.saving = false;
                    });
            });
        },

        _saveEventWatermarkAndSettings() {
            return new Promise((resolve, reject) => {
                this.$refs.watermarkEditor.saveWatermark().then((response) => {
                    console.debug("BACKEND_SAVE_WATERMARK", response);
                    this._saveEventSettings()
                        .then((response) => {
                            resolve();
                        })
                        .catch((error) => {
                            console.error("BACKEND_SET_EVENT_SETTINGS", error);
                            reject();
                        });
                });
            });
        },

        _doSubmit() {
            this.saving = true;

            // imposta il nuovo listino all'evento
            this.event.fkListino = this.pricelistSelected;

            // setta il watermark per l'evento (predefinito o custom)
            this.event.fkWatermark = this.idWatermark;

            if (this.event.fkWatermark == this.event.idWatermarkDefault) {
                // watermark predefinito
                return this._saveEventSettings();
            } else {
                // watermark specifico per evento
                return this._saveEventWatermarkAndSettings();
            }
        },

        onSubmit() {
            if (this.loaded && this.isValid) {
                // in caso di rapporto cambiato => visualizza modale
                if (this.pricelistRatioChanged) {
                    const h = this.$createElement;
                    this.$bvModal
                        .msgBoxConfirm(
                            [
                                h("div", {}, [
                                    "Il listino ha un rapporto inquadratura diverso da quello impostato attualmente."
                                ]),
                                h("div", { class: ["mt-1"] }, [
                                    "Proseguendo sarà necessario ricontrollare le inquadrature delle foto dell'evento."
                                ])
                            ],
                            {
                                title: "Attenzione!",
                                size: "sm",
                                okVariant: "rikorda1",
                                okTitle: "Procedi",
                                cancelTitle: "Annulla",
                                footerClass: "p-2",
                                hideHeaderClose: false,
                                centered: true
                            }
                        )
                        .then((value) => {
                            // salvataggio confermato => chiamata api
                            if (value) {
                                this._doSubmit().then(() => {
                                    this.goToGallery();
                                });
                            }
                        })
                        .catch((err) => {
                            // An error occurred
                            console.error(err);
                        });
                } else {
                    // chiamata api
                    this._doSubmit();
                }
            }
        },

        goToGallery() {
            this.$router.push({
                name: "backend-gallery",
                params: { eventId: this.eventId }
            });
        },

        onPricelistChanged() {
            // check se il rapporto nel listino cambiato
            if (this.event.fkListino == "") {
                this.pricelistRatioChanged =
                    typeof this.pricelistSelected != "undefined";
            } else {
                var pricelistOld = this.pricelistOptions[this.event.fkListino];
                var pricelistNew =
                    this.pricelistOptions[this.pricelistSelected];

                this.pricelistRatioChanged =
                    pricelistOld.ratio != pricelistNew.ratio;
            }
        },

        onTipoWatermarkChanged() {
            this.$nextTick(() => {
                switch (this.tipoWatermark) {
                    case "DEFAULT":
                        this.idWatermark = this.event.idWatermarkDefault;
                        break;

                    case "CUSTOM":
                        if (!this.idWatermarkEvent) {
                            this.$api
                                .backendCreateWatermark()
                                .then((response) => {
                                    console.debug(
                                        "BACKEND_CREATE_WATERMARK",
                                        response
                                    );
                                    this.idWatermarkEvent =
                                        response.idWatermark;
                                    this.idWatermark = this.idWatermarkEvent;
                                })
                                .catch((error) => {
                                    console.error(
                                        "BACKEND_CREATE_WATERMARK",
                                        error
                                    );
                                });
                        } else {
                            this.idWatermark = this.idWatermarkEvent;
                        }
                        break;
                }
            });
        }
    }
};
</script>

<style scoped>
.loading {
    position: absolute;
    top: 50%;
    left: calc(50% - 41px);
}

#be-event-url {
    padding: 10px;
    word-break: break-word;
}
</style>
